<div class="cf-templates-rem-dialog">
  <span class="reminder-title">New Reminder</span>
  <div mat-dialog-title oneDialogTitle>
    <span i18n="@@input-dialog-example.title">Templates</span>
  </div>
  <div mat-dialog-content oneDialogContent class="import-dialog-content">
    <dl-reminder-message-template [isNewFromTemplate]="isNewFromTemplate" [addRowData]="newReminderTemplate" [displayedColumns]="templateColumn" [tableData]="templateData" *ngIf="templateData.length > 0" (isFeedbackOptionAdded)="feedbackOptionAdded($event)" (isReminderRowSelected)="getSelectedRowInTemplate($event)" ></dl-reminder-message-template>
  </div>
  <div mat-dialog-actions oneDialogActions class="import-dialog-actions">
    <button one-secondary-button mat-stroked-button [mat-dialog-close]="true">Cancel</button>
    <div>
      <button (click)="addReminderMessage(true)" class="btn-add-reminder" mat-stroked-button one-secondary-button>
        Create from blank
      </button>
      <button (click)="addTemplateToForm()" color="primary" [disabled]="isAffBtnDisabled" mat-flat-button i18n="@@input-dialog-example.ok-btn">
        Continue
      </button>
    </div>
  </div>
</div>
